<template>
  <div
    class="flex-auto ce-productSheets"
    :class="{'is-mobile': isMobile}">
    <div class="ce-container flex pt4">
      <filter-bar />
      <main>
        <div
          class="ce-notificationsHint"
          v-if="notificationSettingsLink">
          <i18n
            path="productSheets.notificationsHint.content"
            tag="span">
            <a :href="notificationSettingsLink">{{ $t('productSheets.notificationsHint.cta') }}</a>
          </i18n>
        </div>
        <div class="ce-searchResults-topActionsBar flex">
          <div class="ce-mobileFilterBarToggle mr2">
            <button
              class="ce-btn ce-btn-grey"
              @click.prevent="$store.dispatch('toggleMobileFilterBar')">
              <fa-icon icon="filter" />
            </button>
          </div>

          <search-field
            :use-product-sheets-service="true"
            on-search-page
            class="flex-auto"
            :value="searchTerm"
            :active-filters="urlFilters"
            :emit-select="true"
            @selected="$store.dispatch('setSearchTerm', $event.product_name)"
            @search="$store.dispatch('setSearchTerm', $event)" />
        </div>

        <div class="ce-searchResultTypeSelection">
          <button
            :class="{active: activeTab === 'search'}"
            @click.prevent="setTab('search')">
            {{ $t('productSheets.tabs.search') }}
          </button>
          <button
            :class="{active: activeTab === 'mysheets'}"
            @click.prevent="setTab('mysheets')">
            {{ $t('productSheets.tabs.mySheets') }}
          </button>
        </div>

        <document-results
          v-if="activeTab === 'search'" />

        <my-sheets
          v-if="activeTab === 'mysheets'" />
      </main>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SearchField from 'components/product-search/SearchField.vue';
import FilterBar from 'components/product-search/FilterBar.vue';
import DocumentResults from 'components/product-sheets/DocumentResults.vue';
import MySheets from 'components/product-sheets/MySheets.vue';
import { routes as userProfileRoutes } from 'routers/user-profile/routes';

export default {
  mounted() {
    this.fetchFavorites();
  },
  components: {
    SearchField, FilterBar, DocumentResults, MySheets
  },
  computed: {
    ...mapGetters(['urlFilters', 'searchTerm', 'activeTab', 'isMobile']),
    notificationSettingsLink() {
      const notificationSettingsRoute = userProfileRoutes.find((r) => r.name === 'notifications');

      if (notificationSettingsRoute) {
        return `/profile${notificationSettingsRoute.path}`;
      }

      return undefined;
    }
  },
  methods: {
    ...mapActions(['search', 'setTab', 'fetchFavorites'])
  }
};
</script>

<style lang="less">
  @import (reference) '~styles/includes/base';
  @import '~styles/includes/search-type-tabs';

  .ce-productSheets {
    main {
      .flex-auto;
      padding: @space-3;
      background: @color-mono-100;

      @media screen and (min-width: @breakpoint-xl) {
        .ce-mobileFilterBarToggle {
          display: none;
        }
      }

      .ce-documentResults-col {
        padding: 0 @space-3;
        flex-shrink: 0;

        &.ce-col1 {
          width: 102px;

          .ce-documentResult-rowToggle {
            width: 10px;
          }
          .ce-documentResult-selectCta {
            width: 20px;
            .ms(-1);
          }
        }
        &.ce-col2 {
          .flex-auto;
          min-width: 120px;
        }
        &.ce-col3 {
          width: 110px;
        }
        &.ce-col4 {
          width: 200px;
          display: flex;

          .ce-changelog {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        &.ce-col5 {
          width: 90px;
        }
        &.ce-col6 {
          width: 128px; // Up to 4 actions/icons

          .ce-documentResult-downloadCta, .ce-documentResult-favoriteCta {
            width: 16px;
          }
        }
      }

      .ce-searchResult-document-header {
        .ce-documentResults-col {
          &.ce-col3, &.ce-col4 {
            width: auto;
          }
        }
      }

      .ce-documentResults-level2 {
        padding-left: @space-2 + @space-3;
      }

      .ce-documentResults-level3 {
        padding-left: @space-2 + (2 * @space-3);
      }
    }

    .ce-notificationsHint {
      position: relative;
      .ms(-2);
      margin: 0 0 @space-2;
      text-align: right;
    }

    .ce-searchFilterBar {
      .ce-searchFilterBar-resetAllCta {
        @media screen and (min-width: @breakpoint-xl) {
          &.ce-searchFilterBar-resetAllCta--desktop {
            display: flex;
          }
          &.ce-searchFilterBar-resetAllCta--mobile {
            display: none;
          }
        }
      }

      @media screen and (max-width: (@breakpoint-xl - 1)) {
        position: fixed;
        left: 0;
        padding: @space-5 @space-4;
        top: 0;
        z-index: 9090;
        background: @color-mono-95;
        height: 100%;
        transition: all 250ms ease-in-out;
        transform: translateX(-100%);
        overflow: auto;

        .ce-searchFilterBar-doneCta {
          display: block;
          margin-top: @space-2;
        }

        &.is-mobile-visible {
          transform: translateX(0);

          .ce-searchFilterBar-closeCta {
            display: block;
            position: absolute;
            top: @space-1;
            right: @space-1;
            color: @color-text-base;
          }
        }
      }
    }

    &.is-mobile {
      > .ce-container {
        max-width: 100%;
      }

      main {
        padding: @space-4 0;

        .ce-searchResults-topActionsBar {
          padding: 0 @space-4;
        }
      }
    }

    .ce-documentResults, .ce-mySheets {
      line-height: 1.5;
    }
  }
</style>
